<template>
  <div class="loginBackground center">
    <b-container class="bv-example-row">
      <b-row class="align-item-center">
        <b-col md="6">
          <div class="text-center">
            <img
              src="./assets/login_drawing.svg"
              style="max-height: 400px; margin-bottom: -20px;"
              alt="login-drawing"
            />
          </div>
        </b-col>
        <b-col
          md="5"
          style="min-width: 300px; font-family: cerebriSansReg; color: #95aac9!important;"
        >
          <h2 style="font-family: cerebriSansBold; color: black!important;">Sign-In</h2>
          <h3 class="loginWelcomeText" style="color: #95aac9!important;">{{text.loginMsg}}</h3>
          <section id="firebaseui-auth-container"></section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

var firebaseConfig = {
  apiKey: "AIzaSyD2rBEBZHtWepMm6gntmwPWQgSsgtJI6Cs",
  authDomain: "umonite-f82c9.firebaseapp.com",
  databaseURL: "https://umonite-f82c9.firebaseio.com",
  projectId: "umonite-f82c9",
  storageBucket: "umonite-f82c9.appspot.com",
  messagingSenderId: "773640313289",
  appId: "1:773640313289:web:bd9e3cf99b45711cf4f018"
};

firebase.initializeApp(firebaseConfig);

export default {
  name: "Login",
  data() {
    return {
      text: {},
      textEsp: {
        loginMsg: "Selecciona un método para acceder a UMonite."
      },
      textEng: {
        loginMsg: "Choose a sign-in method to UMonite."
      }
    };
  },
  methods: {
    translate(lang) {
      if (lang == "esp") {
        this.text = this.textEsp;
      }
      if (lang == "eng") {
        this.text = this.textEng;
      }
    }
  },
  beforeCreate() {
    self = this;
    firebase.auth().onAuthStateChanged(function(user) {
      if (!user) {
        //router.push("/MenuLogin");
      } else self.$router.push({ path: "/app/dashboard" });
    });
  },
  mounted() {
    /* gets language automatically
    var navLanguage = navigator.language;
    if (navLanguage.substring(0, 2) == "es") this.translate("esp");
    else this.translate("eng"); */
    this.translate("eng");

    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    var uiConfig = {
      signInSuccessUrl: "/app/dashboard", // This redirect can be achived by route using callback.
      signInFlow: "popup",
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        "microsoft.com",
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "invisible", // 'invisible' or 'compact'
            badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
          },
          defaultCountry: "MX"
        }
      ],
      // tosUrl and privacyPolicyUrl accept either url string or a callback
      // function.
      // Terms of service url/callback. "/TermsAndConditions"
      tosUrl: function() {
        window.location.assign("/TermsAndConditions");
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
      // Privacy policy url/callback.
      privacyPolicyUrl: function() {
        window.location.assign("/Privacy");
      }
    };
    // Initialize the FirebaseUI Widget using Firebase.

    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style scoped>
@font-face {
  font-family: cerebriSansBold;
  src: url("../../assets/fonts/Cerebri-Sans/CerebriSans-Bold.ttf");
}
@font-face {
  font-family: cerebriSansReg;
  src: url("../../assets/fonts/Cerebri-Sans/CerebriSans-Regular.ttf");
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loginWelcomeText {
  margin: 35px 20px 35px 20px;
  color: black !important;
  font-size: 15px;
}

.loginBackground {
  background-color: #fff;
  height: 100%;
  width: 100%;
  padding: 20px;
  text-align: center;
}

.loginBox {
  margin: 20px;
  padding-bottom: 20px;
  max-height: auto;
  max-width: 400px;
  display: inline-block;
  margin: auto;
  border-radius: 20px;
  text-transform: uppercase;
}
</style>